import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

interface CategoryNavProps {
  activeSlug: string;
}

export default function CategoryNav({ activeSlug }: CategoryNavProps) {
  return (
    <section className="w-full px-4 md:px-6 py-6">
      <div className="flex items-center gap-2 overflow-x-auto pb-2 scrollbar-hide flex-wrap">
        {categories.map((cat) => (
          <Link
            key={cat.id}
            to={cat.slug === 'all' ? '/' : `/category/${cat.slug}`}
            className={`flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-200 cursor-pointer ${
              activeSlug === cat.slug
                ? 'bg-primary-500 text-background-50'
                : 'bg-background-100 text-foreground-700 hover:bg-background-200 hover:text-foreground-950'
            }`}
          >
            <i className={`${cat.icon} text-sm`}></i>
            {cat.name}
          </Link>
        ))}
      </div>
    </section>
  );
}